<template>
    <ElencoModuliRid />
</template>

<script>
  import ElencoModuliRid from '@/components/ask/pages/ElencoModuliRid.vue'

  export default {
    name: 'PageElencoModuliRid',

    components:{
      ElencoModuliRid
    },
  
    data(){
      return {
      
      }
    },

    created(){
      
    },

    mounted(){
    //   this.$eventBus.emit('page-change', {
    //     target: this,
    //     currentRoute: this.$router.currentRoute.value
    //   })
    },

    methods:{

    },
  }
</script>

<style>

</style>
